var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$emit('clicked', 'true')}}},[_c('button',{class:this.$props.addNew ? 'add-new' : 'single-industry',style:(this.$props.addNew ? 'color:#047cff' : ''),attrs:{"color":this.$props.color}},[_vm._v(" "+_vm._s(this.$props.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }